(() => {
  const completedForms = new WeakSet();
  let synchronization;
  const root = window.Shopify?.routes?.root || '/';

  const syncArticleNumbers = () => {
    if (synchronization) return synchronization;
    synchronization = (async () => {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart could not be read');
      let cart = await response.json();
      for (let index = 0; index < cart.items.length; index += 1) {
        const item = cart.items[index];
        if (!item.sku || item.properties?.Artikelnummer === item.sku) continue;
        const update = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: { ...item.properties, Artikelnummer: item.sku } })
        });
        if (!update.ok) throw new Error('Cart could not be updated');
        cart = await update.json();
        index = -1;
      }
    })().finally(() => { synchronization = undefined; });
    return synchronization;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!(form instanceof HTMLFormElement) || button?.name !== 'checkout') return;
    if (completedForms.delete(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.articleNumbersPending === 'true') return;
    form.dataset.articleNumbersPending = 'true';
    button.setAttribute('aria-busy', 'true');
    try {
      await syncArticleNumbers();
    } catch (error) {
      console.warn('Article number synchronization failed', error);
    } finally {
      delete form.dataset.articleNumbersPending;
      button.removeAttribute('aria-busy');
      completedForms.add(form);
      form.requestSubmit(button);
    }
  }, true);
})();
